/**
 * Hero Product Text Highlight on Scroll
 * Para Shopify - Section Hero Product
 * Aplica <em> progresivo al texto .hero-product__right-text según scroll
 */

(function () {
  'use strict';

  // Configuración
  const CONFIG = {
    textSelector: '.hero-product__right-text',
    triggerPoint: 0.3, // 30% del viewport (más arriba = bloqueo más tarde)
    pixelsPerLine: 100, // Píxeles de scroll por cada línea
    scrollLockEnabled: true, // Bloquear scroll mientras resalta
    debug: false, // Cambiar a true para ver info de debug
  };

  function initTextHighlight() {
    // Detectar si es dispositivo móvil y deshabilitar el efecto
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
      window.innerWidth < 768;

    if (isMobile) {
      if (CONFIG.debug) console.log('Efecto deshabilitado en dispositivos móviles');
      return;
    }

    const container = document.querySelector(CONFIG.textSelector);

    if (!container) {
      if (CONFIG.debug) console.warn('No se encontró:', CONFIG.textSelector);
      return;
    }

    // Guardar HTML original (puede contener tags de Shopify richtext como <p>, <strong>, etc)
    const originalHTML = container.innerHTML.trim();

    // Dividir el HTML en líneas usando <br> como delimitador
    // Esto preserva las etiquetas HTML como <strong> dentro de cada línea
    let segments = [];

    // Dividir por <br>, <br/> o <br />
    const lines = originalHTML.split(/<br\s*\/?>/i);

    lines.forEach((line) => {
      // Limpiar espacios y etiquetas <p> si existen
      let cleanLine = line.replace(/<\/?p>/gi, '').trim();

      if (cleanLine && cleanLine.length > 0) {
        segments.push(cleanLine);
      }
    });

    if (segments.length === 0) {
      if (CONFIG.debug) console.warn('No se pudieron crear segmentos de texto');
      return;
    }

    if (CONFIG.debug) {
      console.log('Segmentos detectados:', segments);
    }

    // Variables de estado
    let currentHighlightIndex = -1;
    let isInRange = false;
    let isLocked = false;
    let lockedScrollPosition = 0;
    let virtualScroll = 0; // Scroll virtual mientras está bloqueado
    let justUnlocked = false; // Para evitar re-bloqueo inmediato
    let lastScrollY = 0; // Para detectar dirección del scroll

    function updateHighlight() {
      const rect = container.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const triggerY = viewportHeight * CONFIG.triggerPoint;
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;

      // Detectar dirección del scroll
      const scrollingDown = scrollY > lastScrollY;
      lastScrollY = scrollY;

      // Debug info
      if (CONFIG.debug) {
        console.log({
          rectTop: Math.round(rect.top),
          triggerY: Math.round(triggerY),
          scrollY: Math.round(scrollY),
          virtualScroll: Math.round(virtualScroll),
          currentIndex: currentHighlightIndex,
          totalSegments: segments.length,
          isLocked: isLocked,
          scrollingDown: scrollingDown,
        });
      }

      // Solo bloquear si estamos scrolleando hacia abajo
      if (!isLocked && !justUnlocked && scrollingDown && rect.top <= triggerY && rect.bottom >= triggerY) {
        // Entramos en la zona de activación
        isLocked = true;
        isInRange = true;
        lockedScrollPosition = scrollY;
        virtualScroll = 0;
        currentHighlightIndex = -1;

        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';

        renderHighlight();
      }

      // Si estamos bloqueados, calcular índice basado en scroll virtual
      if (isLocked) {
        // Desbloquear si scrollean hacia arriba lo suficiente (scroll virtual negativo)
        if (virtualScroll < -CONFIG.pixelsPerLine * 0.5) {
          unlockScroll();
          return;
        }

        let newIndex;
        if (virtualScroll < CONFIG.pixelsPerLine) {
          newIndex = -1;
        } else {
          newIndex = Math.floor(virtualScroll / CONFIG.pixelsPerLine) - 1;
        }

        // Limitar al rango válido
        newIndex = Math.max(-1, Math.min(newIndex, segments.length - 1));

        if (newIndex !== currentHighlightIndex) {
          currentHighlightIndex = newIndex;
          renderHighlight();
        }

        // Desbloquear al completar la última línea y scrollear un poco más
        if (newIndex === segments.length - 1) {
          // Desbloquear cuando superamos el scroll de la última línea + un pequeño margen
          const scrollForLastLine = (segments.length + 1) * CONFIG.pixelsPerLine;
          if (virtualScroll > scrollForLastLine) {
            unlockScroll();
          }
        }
      }
    }

    function unlockScroll() {
      if (!isLocked) return;

      isLocked = false;
      isInRange = false;
      justUnlocked = true; // Marcar que acabamos de desbloquear

      // Restaurar el HTML original (sin resaltado)
      container.innerHTML = originalHTML;
      currentHighlightIndex = -1;

      // Restaurar el scroll
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';

      // Si el virtual scroll es negativo, significa que scrollearon hacia arriba
      // En ese caso, retroceder en lugar de avanzar
      let targetScroll;
      if (virtualScroll < 0) {
        // Retroceder un poco para salir de la zona de bloqueo hacia arriba
        targetScroll = Math.max(0, lockedScrollPosition - CONFIG.pixelsPerLine * 2);
      } else {
        // Avanzar bastante para asegurar que salimos completamente de la zona
        targetScroll = lockedScrollPosition + CONFIG.pixelsPerLine * 3; // 300px
      }
      
      window.scrollTo(0, targetScroll);

      // Reset virtual scroll
      virtualScroll = 0;

      // Resetear la bandera después de 1 segundo para asegurar que no se re-bloquea
      setTimeout(() => {
        justUnlocked = false;
      }, 1000);
    }

    function renderHighlight() {
      if (currentHighlightIndex < 0) {
        container.innerHTML = originalHTML;
        return;
      }

      // Reconstruir HTML con los segmentos resaltados progresivamente
      let html = '<p>';
      segments.forEach((segment, index) => {
        // Resaltar solo la línea actual
        if (index === currentHighlightIndex) {
          html += `<em>${segment}</em>`;
        } else {
          html += segment;
        }

        // Añadir <br> entre líneas (excepto después de la última)
        if (index < segments.length - 1) {
          html += '<br>';
        }
      });
      html += '</p>';

      container.innerHTML = html;
    }

    // Event listeners para manejar el scroll
    let ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateHighlight();
          ticking = false;
        });
        ticking = true;
      }
    }

    // Interceptar eventos de wheel cuando está bloqueado (desktop)
    function onWheel(e) {
      if (isLocked) {
        e.preventDefault();

        // Acumular el scroll virtual (positivo = abajo, negativo = arriba)
        virtualScroll += e.deltaY;

        updateHighlight();
      }
    }

    // Variables para touch events (mobile)
    let touchStartY = 0;
    let touchLastY = 0;

    function onTouchStart(e) {
      if (isLocked) {
        touchStartY = e.touches[0].clientY;
        touchLastY = touchStartY;
      }
    }

    function onTouchMove(e) {
      if (isLocked) {
        e.preventDefault();

        const touchY = e.touches[0].clientY;
        const deltaY = touchLastY - touchY; // Invertido: hacia arriba = positivo
        touchLastY = touchY;

        // Acumular el scroll virtual
        virtualScroll += deltaY;

        updateHighlight();
      }
    }

    function onTouchEnd(e) {
      if (isLocked) {
        touchStartY = 0;
        touchLastY = 0;
      }
    }

    // Bind events
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('wheel', onWheel, { passive: false }); // Desktop
    window.addEventListener('touchstart', onTouchStart, { passive: false }); // Mobile
    window.addEventListener('touchmove', onTouchMove, { passive: false }); // Mobile
    window.addEventListener('touchend', onTouchEnd, { passive: false }); // Mobile

    // También actualizar en resize (por si cambia el layout)
    let resizeTimeout;
    window.addEventListener(
      'resize',
      () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (isInRange) {
            renderHighlight();
          }
        }, 250);
      },
      { passive: true },
    );

    // Check inicial
    updateHighlight();

    if (CONFIG.debug) {
      console.log(`✓ Text highlight iniciado con ${segments.length} segmentos`);
    }
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTextHighlight);
  } else {
    initTextHighlight();
  }

  // Re-inicializar si Shopify hace reload de sección (theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initTextHighlight);
  }
})();
